import { UnlinkIcon } from "lucide-react";

interface CustomNoDataProps {
  msg?: string;
}

/**
 * CustomNoData — Universal empty state component
 * For displaying when no data is available in pages and components
 */
export function CustomNoData({
  msg = "No data found for this exercise.",
}: CustomNoDataProps) {
  return (
    <div className="flex flex-col justify-center items-center px-10 text-center min-h-[40vh]">
      <p className="text-tx-muted mb-10">
        <UnlinkIcon size={48} />
      </p>
      <div className="text-tx-muted text-base leading-5">{msg}</div>
    </div>
  );
}

export default CustomNoData;
